import { render, staticRenderFns } from "./archive-warning-modal.vue?vue&type=template&id=1c61513a&scoped=true&"
import script from "./archive-warning-modal.vue?vue&type=script&lang=js&"
export * from "./archive-warning-modal.vue?vue&type=script&lang=js&"
import style0 from "./archive-warning-modal.vue?vue&type=style&index=0&id=1c61513a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c61513a",
  null
  
)

export default component.exports